import { useState } from 'react';
import logger from '../../utils/logger';

// Sous-hook Messagerie : signatures email (chargement, résolution par compte,
// génération du HTML de signature).
export function useMailSignatures({ backendUrl, authToken }) {
  const [signatures, setSignatures] = useState([]);

  const loadSignatures = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/admin/mail/signatures`, {
        headers: { 'Authorization': `Bearer ${authToken}` }
      });

      if (response.ok) {
        const data = await response.json();
        setSignatures(data);
      }
    } catch (error) {
      logger.error('Error loading signatures:', error);
    }
  };

  const getSignatureForAccount = (accountId) => {
    return signatures.find(s => s.email_account_id === accountId);
  };

  const generateSignatureHTML = (signature, backendUrlOverride) => {
    if (!signature) return '';

    let html = '<br><br>--<br>';

    // Contenu principal
    if (signature.content_html) {
      html += signature.content_html;
    }

    // Logo : privilégier base64 inline (pas de token, pas d'expiration)
    // Pour les anciennes signatures avec URL relative, convertir en URL absolue
    if (signature.logo_enabled && signature.logo_url) {
      let logoSrc = signature.logo_url;
      // Si c'est une URL relative, la rendre absolue avec backendUrl
      if (logoSrc && logoSrc.startsWith('/') && backendUrlOverride) {
        logoSrc = `${backendUrlOverride}${logoSrc}`;
      }
      // Supprimer le token JWT des anciennes URLs (il serait expiré de toute façon)
      if (logoSrc && logoSrc.includes('?token=')) {
        logoSrc = logoSrc.split('?token=')[0];
      }
      html += `<br><img src="${logoSrc}" alt="Logo" style="max-height: 60px; max-width: 200px;" />`;
    }

    // Réseaux sociaux
    const activeSocials = (signature.social_links || []).filter(s => s.enabled && s.url);
    if (activeSocials.length > 0) {
      html += '<br>';
      activeSocials.forEach(social => {
        html += `<a href="${social.url}" style="margin-right: 10px; text-decoration: none;">${social.platform}</a>`;
      });
    }

    // Site web
    if (signature.website_enabled && signature.website_url) {
      html += `<br><a href="${signature.website_url}">🌐 ${signature.website_url}</a>`;
    }

    // Disclaimer
    if (signature.disclaimer_enabled && signature.disclaimer_text) {
      html += `<br><br><span style="font-size: 11px; color: #6b7280;">${signature.disclaimer_text.replace(/\n/g, '<br>')}</span>`;
    }

    return html;
  };

  return { signatures, loadSignatures, getSignatureForAccount, generateSignatureHTML };
}
